/// <reference path="../../../../../typings/jquery.d.ts"/>
import { AppUtils } from '../../../../../../shared/utils/index';
import { User } from '../../../../../../shared/models/api/User/User';
import { DamageFormModel } from '../../models/DamageFormModel';
import { BasicApplicationRouter } from '../../../../../../shared/services/BasicApplicationRouter';
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppViewService } from '../../services/AppViewService';
import { CheckboxStateEnum } from '../../../../../../shared/enums/CheckboxSelectionType';
import { VesDamageValidationService } from '../../../../../../shared/services/VesDamageValidationService';

export class DamageOhcPageController implements StepController {
	private readonly $ctx: JQuery;
	private readonly applicationRouter: BasicApplicationRouter<DamageDeclarationOhcAppDefinition>;
	private readonly user: User;
	private readonly options: DamageDeclarationOhcOptions;
	private readonly appViewService: AppViewService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly loader: BasicLoader<DamageDeclarationOhcAppDefinition>;
	private appValidationService: VesDamageValidationService;
	private readonly parent: AppController;


	constructor(parent: AppController, options: DamageDeclarationOhcOptions, loader: BasicLoader<DamageDeclarationOhcAppDefinition>, user: User) {
		this.options = options;
		this.loader = loader;
		this.user = user;
		this.$ctx = $(options.$ctx);
		this.parent = parent;

		this.applicationRouter = new BasicApplicationRouter(options);
		this.appPersistenceService = new AppPersistenceService(options);
		this.appViewService = new AppViewService(parent, options, loader);
	}

	public start(): void {
		const viewConfig = {
			data: this.getViewOptions(),
			templateurl: this.options.app.currenttemplate.templateurl,
			campaignurls: this.options.app.campaignurls,
			parent: this,
			$ctx: this.$ctx,
			options: this.options,
			callback: this.afterRenderApp
		};
		this.appViewService.render(viewConfig);
	}

	/**
	 * returns view options for the page.
	 * only variables defined in here are available in the view to use with handlebars.
	 */
	private getViewOptions(): { [key: string]: any } {
		const damageModel: DamageFormModel = this.appPersistenceService.getDamageOhcFormModel();
		return {
			User: this.user,
			DamageModel: damageModel,
			nexturl: this.options.app.nexturl || '',
			prevurl: this.options.app.prevurl || '',
		};
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			this.appValidationService = new VesDamageValidationService({ options: this.options }, this.appViewService.getForm(), true);
			this.parent.afterRenderApp();
			const formModel: DamageFormModel = this.appPersistenceService.getDamageOhcFormModel();
			if (formModel !== undefined) {
				this.appViewService.updateEigeneAngabenTextareaContainer(formModel.SchadenTyp);
			}

			this.markUntouchedSelectionsAsUndefined(formModel);
			this.appViewService.triggerPersonFieldsChange();

			this.appViewService.addDamageListeners(
				this.personChangeListener.bind(this),
				this.damageTypeChangeListener.bind(this),
				this.viewChangeListener.bind(this),
				this.submitListener.bind(this),
				this.removeDependedErrorsOnSchadentypChangeListener.bind(this)
			);
		});
		this.appViewService.restoreSectionBackground();
		AppUtils.View.stopLoader("damagedeclarationohc initApplication");
		AppUtils.View.scrollTop();
		this.appViewService.showLightBoxForForeignLanguages();
	}

	/**
	 * Set properties manual as undefined when user has not selected an option for property
	 */
	private markUntouchedSelectionsAsUndefined(formModel: DamageFormModel): void {
		if (formModel) {
			if (formModel.Behandlung === undefined) {
				formModel.Behandlung = CheckboxStateEnum.CHECKBOX_UNTOUCHED;
			}
			if (formModel.BetroffenePersonGemeldet === undefined) {
				formModel.BetroffenePersonGemeldet = CheckboxStateEnum.CHECKBOX_UNTOUCHED;
			}
		}
	}

	private personChangeListener(): void {
		this.appViewService.clearPersonFields();
	}

	private damageTypeChangeListener(): void {
		this.appViewService.clearFieldsDependOnDamageTyp();
	}

	/**
	 * Stores changes the DamageOhcFormModel on page changes
	 */
	private viewChangeListener(): void {
		AppUtils.Helper.scheduleTask(() => {
			const formModel: DamageFormModel = this.appViewService.getFormModelFromDamageView();
			this.appViewService.updateEigeneAngabenTextareaContainer(formModel.SchadenTyp);
			this.appPersistenceService.setDamageOhcFormModel(formModel);
			this.appViewService.restoreSectionBackground();
		}, 'user-visible');
	}

	private removeDependedErrorsOnSchadentypChangeListener(): void {
		this.appValidationService.removeDependedErrorsOnSchadentypChange();
	}

	/**
	 * Shows the documentsBillsPage when this page is valid
	 */
	private submitListener(event: JQuery.Event): void {
		event.preventDefault();

		if (this.appValidationService.isValid()) {
			AppUtils.View.startLoader("DamageOhcPageController submitListener");
			this.viewChangeListener();
			this.applicationRouter.next();
			AppUtils.View.stopLoader("DamageOhcPageController submitListener");
		}
	}
}
